import _definePage_default_0 from '/home/welcomepetobio/projects/vue-cdms/src/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/welcomepetobio/projects/vue-cdms/src/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/index.vue?definePage&vue'
import _definePage_default_4 from '/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/answer/[project]/[subject]/[schedule].vue?definePage&vue'
import _definePage_default_5 from '/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/create.vue?definePage&vue'
import _definePage_default_6 from '/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/edit/[id].vue?definePage&vue'
import _definePage_default_7 from '/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/view/[id].vue?definePage&vue'
import _definePage_default_8 from '/home/welcomepetobio/projects/vue-cdms/src/pages/assigntest/index.vue?definePage&vue'
import _definePage_default_9 from '/home/welcomepetobio/projects/vue-cdms/src/pages/build/index.vue?definePage&vue'
import _definePage_default_10 from '/home/welcomepetobio/projects/vue-cdms/src/pages/dashboard/index.vue?definePage&vue'
import _definePage_default_11 from '/home/welcomepetobio/projects/vue-cdms/src/pages/data/audit-trail/index.vue?definePage&vue'
import _definePage_default_12 from '/home/welcomepetobio/projects/vue-cdms/src/pages/data/dataset/index.vue?definePage&vue'
import _definePage_default_13 from '/home/welcomepetobio/projects/vue-cdms/src/pages/data/document/index.vue?definePage&vue'
import _definePage_default_14 from '/home/welcomepetobio/projects/vue-cdms/src/pages/data/freezing/index.vue?definePage&vue'
import _definePage_default_15 from '/home/welcomepetobio/projects/vue-cdms/src/pages/data/locking/index.vue?definePage&vue'
import _definePage_default_16 from '/home/welcomepetobio/projects/vue-cdms/src/pages/data/review/index.vue?definePage&vue'
import _definePage_default_17 from '/home/welcomepetobio/projects/vue-cdms/src/pages/data/review/[id].vue?definePage&vue'
import _definePage_default_18 from '/home/welcomepetobio/projects/vue-cdms/src/pages/forgot-password.vue?definePage&vue'
import _definePage_default_19 from '/home/welcomepetobio/projects/vue-cdms/src/pages/login.vue?definePage&vue'
import _definePage_default_20 from '/home/welcomepetobio/projects/vue-cdms/src/pages/manage/permissions/index.vue?definePage&vue'
import _definePage_default_21 from '/home/welcomepetobio/projects/vue-cdms/src/pages/manage/sites/index.vue?definePage&vue'
import _definePage_default_22 from '/home/welcomepetobio/projects/vue-cdms/src/pages/manage/sites/create/index.vue?definePage&vue'
import _definePage_default_23 from '/home/welcomepetobio/projects/vue-cdms/src/pages/manage/sites/edit/[id].vue?definePage&vue'
import _definePage_default_24 from '/home/welcomepetobio/projects/vue-cdms/src/pages/manage/users/index.vue?definePage&vue'
import _definePage_default_25 from '/home/welcomepetobio/projects/vue-cdms/src/pages/manage/users/create/index.vue?definePage&vue'
import _definePage_default_26 from '/home/welcomepetobio/projects/vue-cdms/src/pages/manage/users/edit/[id].vue?definePage&vue'
import _definePage_default_27 from '/home/welcomepetobio/projects/vue-cdms/src/pages/management/permissions/index.vue?definePage&vue'
import _definePage_default_28 from '/home/welcomepetobio/projects/vue-cdms/src/pages/not-authorized.vue?definePage&vue'
import _definePage_default_29 from '/home/welcomepetobio/projects/vue-cdms/src/pages/projects/index.vue?definePage&vue'
import _definePage_default_30 from '/home/welcomepetobio/projects/vue-cdms/src/pages/projects/create/index.vue?definePage&vue'
import _definePage_default_31 from '/home/welcomepetobio/projects/vue-cdms/src/pages/projects/modify/[id].vue?definePage&vue'
import _definePage_default_32 from '/home/welcomepetobio/projects/vue-cdms/src/pages/register.vue?definePage&vue'
import _definePage_default_33 from '/home/welcomepetobio/projects/vue-cdms/src/pages/rtms/drug-management/index.vue?definePage&vue'
import _definePage_default_34 from '/home/welcomepetobio/projects/vue-cdms/src/pages/rtms/inventory/index.vue?definePage&vue'
import _definePage_default_35 from '/home/welcomepetobio/projects/vue-cdms/src/pages/rtms/supply/index.vue?definePage&vue'
import _definePage_default_36 from '/home/welcomepetobio/projects/vue-cdms/src/pages/setup-password/[token].vue?definePage&vue'
import _definePage_default_37 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sms/index.vue?definePage&vue'
import _definePage_default_38 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/sites/index.vue?definePage&vue'
import _definePage_default_39 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/sites/create/index.vue?definePage&vue'
import _definePage_default_40 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/sites/edit/[id].vue?definePage&vue'
import _definePage_default_41 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/index.vue?definePage&vue'
import _definePage_default_42 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/create.vue?definePage&vue'
import _definePage_default_43 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/edit/[id].vue?definePage&vue'
import _definePage_default_44 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/index_backup_0825.vue?definePage&vue'
import _definePage_default_45 from '/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/index_backup_0901.vue?definePage&vue'
import _definePage_default_46 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/index.vue?definePage&vue'
import _definePage_default_47 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/answer/[project]/[subject]/[schedule].vue?definePage&vue'
import _definePage_default_48 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/create.vue?definePage&vue'
import _definePage_default_49 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/edit/[id].vue?definePage&vue'
import _definePage_default_50 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/view/[id].vue?definePage&vue'
import _definePage_default_51 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/index.vue?definePage&vue'
import _definePage_default_52 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/answer/[project]/[subject]/[schedule].vue?definePage&vue'
import _definePage_default_53 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/create.vue?definePage&vue'
import _definePage_default_54 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/edit/[id].vue?definePage&vue'
import _definePage_default_55 from '/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/view/[id].vue?definePage&vue'
import _definePage_default_56 from '/home/welcomepetobio/projects/vue-cdms/src/pages/survey/index.vue?definePage&vue'
import _definePage_default_57 from '/home/welcomepetobio/projects/vue-cdms/src/pages/survey/answer/[project]/[subject]/[schedule].vue?definePage&vue'
import _definePage_default_58 from '/home/welcomepetobio/projects/vue-cdms/src/pages/survey/create.vue?definePage&vue'
import _definePage_default_59 from '/home/welcomepetobio/projects/vue-cdms/src/pages/survey/edit/[id].vue?definePage&vue'
import _definePage_default_60 from '/home/welcomepetobio/projects/vue-cdms/src/pages/survey/index_backup.vue?definePage&vue'
import _definePage_default_61 from '/home/welcomepetobio/projects/vue-cdms/src/pages/survey/view/[id].vue?definePage&vue'
import _definePage_default_62 from '/home/welcomepetobio/projects/vue-cdms/src/pages/survey-mobile/[id].vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/assignment',
    /* internal name: 'assignment' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'assignment',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/index.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
      {
        path: 'answer',
        /* internal name: 'assignment-answer' */
        /* no component */
        children: [
          {
            path: ':project',
            /* internal name: 'assignment-answer-project' */
            /* no component */
            children: [
              {
                path: ':subject',
                /* internal name: 'assignment-answer-project-subject' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':schedule',
                    name: 'assignment-answer-project-subject-schedule',
                    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/answer/[project]/[subject]/[schedule].vue'),
                    /* no children */
                  },
  _definePage_default_4
  )
                ],
              }
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'assignment-create',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/create.vue'),
        /* no children */
      },
  _definePage_default_5
  ),
      {
        path: 'edit',
        /* internal name: 'assignment-edit' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'assignment-edit-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/edit/[id].vue'),
            /* no children */
          },
  _definePage_default_6
  )
        ],
      },
      {
        path: 'view',
        /* internal name: 'assignment-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'assignment-view-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/assignment/view/[id].vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      }
    ],
  },
  {
    path: '/assigntest',
    /* internal name: 'assigntest' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'assigntest',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/assigntest/index.vue'),
        /* no children */
      },
  _definePage_default_8
  )
    ],
  },
  {
    path: '/build',
    /* internal name: 'build' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'build',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/build/index.vue'),
        /* no children */
      },
  _definePage_default_9
  )
    ],
  },
  {
    path: '/dashboard',
    /* internal name: 'dashboard' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'dashboard',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/dashboard/index.vue'),
        /* no children */
      },
  _definePage_default_10
  )
    ],
  },
  {
    path: '/data',
    /* internal name: 'data' */
    /* no component */
    children: [
      {
        path: 'audit-trail',
        /* internal name: 'data-audit-trail' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'data-audit-trail',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/data/audit-trail/index.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      },
      {
        path: 'dataset',
        /* internal name: 'data-dataset' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'data-dataset',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/data/dataset/index.vue'),
            /* no children */
          },
  _definePage_default_12
  )
        ],
      },
      {
        path: 'document',
        /* internal name: 'data-document' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'data-document',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/data/document/index.vue'),
            /* no children */
          },
  _definePage_default_13
  )
        ],
      },
      {
        path: 'freezing',
        /* internal name: 'data-freezing' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'data-freezing',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/data/freezing/index.vue'),
            /* no children */
          },
  _definePage_default_14
  )
        ],
      },
      {
        path: 'locking',
        /* internal name: 'data-locking' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'data-locking',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/data/locking/index.vue'),
            /* no children */
          },
  _definePage_default_15
  )
        ],
      },
      {
        path: 'review',
        /* internal name: 'data-review' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'data-review',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/data/review/index.vue'),
            /* no children */
          },
  _definePage_default_16
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'data-review-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/data/review/[id].vue'),
            /* no children */
          },
  _definePage_default_17
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_18
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_19
  ),
  {
    path: '/manage',
    /* internal name: 'manage' */
    /* no component */
    children: [
      {
        path: 'permissions',
        /* internal name: 'manage-permissions' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'manage-permissions',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/permissions/index.vue'),
            /* no children */
          },
  _definePage_default_20
  ),
          {
            path: 'temp',
            name: 'manage-permissions-temp',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/permissions/temp.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sites',
        /* internal name: 'manage-sites' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'manage-sites',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/sites/index.vue'),
            /* no children */
          },
  _definePage_default_21
  ),
          {
            path: 'create',
            /* internal name: 'manage-sites-create' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'manage-sites-create',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/sites/create/index.vue'),
                /* no children */
              },
  _definePage_default_22
  )
            ],
          },
          {
            path: 'edit',
            /* internal name: 'manage-sites-edit' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'manage-sites-edit-id',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/sites/edit/[id].vue'),
                /* no children */
              },
  _definePage_default_23
  )
            ],
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'manage-users' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'manage-users',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/users/index.vue'),
            /* no children */
          },
  _definePage_default_24
  ),
          {
            path: 'create',
            /* internal name: 'manage-users-create' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'manage-users-create',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/users/create/index.vue'),
                /* no children */
              },
  _definePage_default_25
  )
            ],
          },
          {
            path: 'edit',
            /* internal name: 'manage-users-edit' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'manage-users-edit-id',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/manage/users/edit/[id].vue'),
                /* no children */
              },
  _definePage_default_26
  )
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/management',
    /* internal name: 'management' */
    /* no component */
    children: [
      {
        path: 'permissions',
        /* internal name: 'management-permissions' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'management-permissions',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/management/permissions/index.vue'),
            /* no children */
          },
  _definePage_default_27
  ),
          {
            path: 'temp',
            name: 'management-permissions-temp',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/management/permissions/temp.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'sites',
        /* internal name: 'management-sites' */
        /* no component */
        children: [
          {
            path: '',
            name: 'management-sites',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/management/sites/index.vue'),
            /* no children */
          },
          {
            path: 'create',
            /* internal name: 'management-sites-create' */
            /* no component */
            children: [
              {
                path: '',
                name: 'management-sites-create',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/management/sites/create/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'edit',
            /* internal name: 'management-sites-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'management-sites-edit-id',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/management/sites/edit/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'management-users' */
        /* no component */
        children: [
          {
            path: '',
            name: 'management-users',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/management/users/index.vue'),
            /* no children */
          },
          {
            path: 'edit',
            /* internal name: 'management-users-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'management-users-edit-id',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/management/users/edit/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_28
  ),
  {
    path: '/projects',
    /* internal name: 'projects' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'projects',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/projects/index.vue'),
        /* no children */
      },
  _definePage_default_29
  ),
      {
        path: 'create',
        /* internal name: 'projects-create' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'projects-create',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/projects/create/index.vue'),
            /* no children */
          },
  _definePage_default_30
  )
        ],
      },
      {
        path: 'modify',
        /* internal name: 'projects-modify' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'projects-modify-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/projects/modify/[id].vue'),
            /* no children */
          },
  _definePage_default_31
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/register.vue'),
    /* no children */
  },
  _definePage_default_32
  ),
  {
    path: '/rtms',
    /* internal name: 'rtms' */
    /* no component */
    children: [
      {
        path: 'drug-management',
        /* internal name: 'rtms-drug-management' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'rtms-drug-management',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/rtms/drug-management/index.vue'),
            /* no children */
          },
  _definePage_default_33
  )
        ],
      },
      {
        path: 'inventory',
        /* internal name: 'rtms-inventory' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'rtms-inventory',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/rtms/inventory/index.vue'),
            /* no children */
          },
  _definePage_default_34
  )
        ],
      },
      {
        path: 'supply',
        /* internal name: 'rtms-supply' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'rtms-supply',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/rtms/supply/index.vue'),
            /* no children */
          },
  _definePage_default_35
  )
        ],
      }
    ],
  },
  {
    path: '/setup-password',
    /* internal name: 'setup-password' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':token',
        name: 'setup-password-token',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/setup-password/[token].vue'),
        /* no children */
      },
  _definePage_default_36
  )
    ],
  },
  {
    path: '/sms',
    /* internal name: 'sms' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'sms',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sms/index.vue'),
        /* no children */
      },
  _definePage_default_37
  )
    ],
  },
  {
    path: '/sources',
    /* internal name: 'sources' */
    /* no component */
    children: [
      {
        path: 'sites',
        /* internal name: 'sources-sites' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'sources-sites',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/sites/index.vue'),
            /* no children */
          },
  _definePage_default_38
  ),
          {
            path: 'create',
            /* internal name: 'sources-sites-create' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: '',
                name: 'sources-sites-create',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/sites/create/index.vue'),
                /* no children */
              },
  _definePage_default_39
  )
            ],
          },
          {
            path: 'edit',
            /* internal name: 'sources-sites-edit' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'sources-sites-edit-id',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/sites/edit/[id].vue'),
                /* no children */
              },
  _definePage_default_40
  )
            ],
          }
        ],
      },
      {
        path: 'users',
        /* internal name: 'sources-users' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'sources-users',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/index.vue'),
            /* no children */
          },
  _definePage_default_41
  ),
  _mergeRouteRecord(
          {
            path: 'create',
            name: 'sources-users-create',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/create.vue'),
            /* no children */
          },
  _definePage_default_42
  ),
          {
            path: 'edit',
            /* internal name: 'sources-users-edit' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':id',
                name: 'sources-users-edit-id',
                component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/edit/[id].vue'),
                /* no children */
              },
  _definePage_default_43
  )
            ],
          },
  _mergeRouteRecord(
          {
            path: 'index_backup_0825',
            name: 'sources-users-index-backup0825',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/index_backup_0825.vue'),
            /* no children */
          },
  _definePage_default_44
  ),
  _mergeRouteRecord(
          {
            path: 'index_backup_0901',
            name: 'sources-users-index-backup0901',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/sources/users/index_backup_0901.vue'),
            /* no children */
          },
  _definePage_default_45
  )
        ],
      }
    ],
  },
  {
    path: '/subjects',
    /* internal name: 'subjects' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'subjects',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/index.vue'),
        /* no children */
      },
  _definePage_default_46
  ),
      {
        path: 'answer',
        /* internal name: 'subjects-answer' */
        /* no component */
        children: [
          {
            path: ':project',
            /* internal name: 'subjects-answer-project' */
            /* no component */
            children: [
              {
                path: ':subject',
                /* internal name: 'subjects-answer-project-subject' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':schedule',
                    name: 'subjects-answer-project-subject-schedule',
                    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/answer/[project]/[subject]/[schedule].vue'),
                    /* no children */
                  },
  _definePage_default_47
  )
                ],
              }
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'subjects-create',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/create.vue'),
        /* no children */
      },
  _definePage_default_48
  ),
      {
        path: 'edit',
        /* internal name: 'subjects-edit' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'subjects-edit-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/edit/[id].vue'),
            /* no children */
          },
  _definePage_default_49
  )
        ],
      },
      {
        path: 'view',
        /* internal name: 'subjects-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'subjects-view-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjects/view/[id].vue'),
            /* no children */
          },
  _definePage_default_50
  )
        ],
      }
    ],
  },
  {
    path: '/subjectsV2',
    /* internal name: 'subjects-v2' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'subjects-v2',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/index.vue'),
        /* no children */
      },
  _definePage_default_51
  ),
      {
        path: 'answer',
        /* internal name: 'subjects-v2-answer' */
        /* no component */
        children: [
          {
            path: ':project',
            /* internal name: 'subjects-v2-answer-project' */
            /* no component */
            children: [
              {
                path: ':subject',
                /* internal name: 'subjects-v2-answer-project-subject' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':schedule',
                    name: 'subjects-v2-answer-project-subject-schedule',
                    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/answer/[project]/[subject]/[schedule].vue'),
                    /* no children */
                  },
  _definePage_default_52
  )
                ],
              }
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'subjects-v2-create',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/create.vue'),
        /* no children */
      },
  _definePage_default_53
  ),
      {
        path: 'edit',
        /* internal name: 'subjects-v2-edit' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'subjects-v2-edit-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/edit/[id].vue'),
            /* no children */
          },
  _definePage_default_54
  )
        ],
      },
      {
        path: 'view',
        /* internal name: 'subjects-v2-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'subjects-v2-view-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/subjectsV2/view/[id].vue'),
            /* no children */
          },
  _definePage_default_55
  )
        ],
      }
    ],
  },
  {
    path: '/survey',
    /* internal name: 'survey' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'survey',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/survey/index.vue'),
        /* no children */
      },
  _definePage_default_56
  ),
      {
        path: 'answer',
        /* internal name: 'survey-answer' */
        /* no component */
        children: [
          {
            path: ':project',
            /* internal name: 'survey-answer-project' */
            /* no component */
            children: [
              {
                path: ':subject',
                /* internal name: 'survey-answer-project-subject' */
                /* no component */
                children: [
  _mergeRouteRecord(
                  {
                    path: ':schedule',
                    name: 'survey-answer-project-subject-schedule',
                    component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/survey/answer/[project]/[subject]/[schedule].vue'),
                    /* no children */
                  },
  _definePage_default_57
  )
                ],
              }
            ],
          }
        ],
      },
  _mergeRouteRecord(
      {
        path: 'create',
        name: 'survey-create',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/survey/create.vue'),
        /* no children */
      },
  _definePage_default_58
  ),
      {
        path: 'edit',
        /* internal name: 'survey-edit' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'survey-edit-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/survey/edit/[id].vue'),
            /* no children */
          },
  _definePage_default_59
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'index_backup',
        name: 'survey-index-backup',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/survey/index_backup.vue'),
        /* no children */
      },
  _definePage_default_60
  ),
      {
        path: 'view',
        /* internal name: 'survey-view' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'survey-view-id',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/survey/view/[id].vue'),
            /* no children */
          },
  _definePage_default_61
  )
        ],
      }
    ],
  },
  {
    path: '/survey-mobile',
    /* internal name: 'survey-mobile' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'survey-mobile-id',
        component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/survey-mobile/[id].vue'),
        /* no children */
      },
  _definePage_default_62
  )
    ],
  },
  {
    path: '/template',
    /* internal name: 'template' */
    /* no component */
    children: [
      {
        path: 'draggable',
        /* internal name: 'template-draggable' */
        /* no component */
        children: [
          {
            path: '',
            name: 'template-draggable',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/template/draggable/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'draggable-table',
        /* internal name: 'template-draggable-table' */
        /* no component */
        children: [
          {
            path: '',
            name: 'template-draggable-table',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/template/draggable-table/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'html2pdf',
        /* internal name: 'template-html2pdf' */
        /* no component */
        children: [
          {
            path: '',
            name: 'template-html2pdf',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/template/html2pdf/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'store',
        /* internal name: 'template-store' */
        /* no component */
        children: [
          {
            path: '',
            name: 'template-store',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/template/store/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'treeview',
        /* internal name: 'template-treeview' */
        /* no component */
        children: [
          {
            path: '',
            name: 'template-treeview',
            component: () => import('/home/welcomepetobio/projects/vue-cdms/src/pages/template/treeview/index.vue'),
            /* no children */
          }
        ],
      }
    ],
  }
]
